class FontFactory {
  createFont(family: string, source: string) {
    return new FontFace(family, source);
  }
}

export default new FontFactory();
